import CardForItem from "../../../customUiForCs/CardForItem";

export default function ZoneCard({ data }) {
  return (
    <CardForItem
      itemType={"ZONE"}
      title={data.name}
      line1={[{ text: data.description }]}
      line2={[{ text: `Personnel : ${data.personnelCount}` }]}
      editPath="edit-zone"
      pagePath={"zone"}
      itemID={data._id}
    />
  );
}
